<template>
    <div>
        <v-container fluid class="pa-0">
            <div class="search-bar">
                <v-layout row wrap>
                    <v-flex xs12 sm6 md6>
                        <div class="list-title">
                            <h3>Complementos de Pago</h3>
                        </div>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex sx12 sm4 md3 px-3>
                        <v-btn solo color="primary" @click="exportToCSV()">Exportar CSV</v-btn>
                    </v-flex>
                </v-layout>
            </div>
        </v-container>

        <div class="search-bar">
            <v-container fluid class="pa-0">
                <v-layout row wrap>
                    <v-flex xs12 sm6 md4 lg3>
                        <v-menu
                            ref="dateCreatedIni"
                            :close-on-content-click="false"
                            v-model="dateCreatedIni"
                            :nudge-right="40"
                            :return-value.sync="search.createdAtIni"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                            <v-text-field class="lance no-right-padding"
                                slot="activator"
                                :value="formatDate(search.createdAtIni)"
                                label="Fecha Inicial de Pago"
                                append-icon="event"
                                readonly>
                            </v-text-field>
                            <v-date-picker v-model="search.createdAtIni" show-current no-title scrollable locale="es" :header-date-format="formatCalendarHeader">
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="search.createdAtIni=null; $refs.dateCreatedIni.save(search.createdAtIni); searchOnTable();">Cancelar</v-btn>
                                <v-btn flat color="primary" @click="$refs.dateCreatedIni.save(search.createdAtIni); searchOnTable();">Aceptar</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                        <v-menu
                            ref="dateCreatedFin"
                            :close-on-content-click="false"
                            v-model="dateCreatedFin"
                            :nudge-right="40"
                            :return-value.sync="search.createdAtFin"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                            <v-text-field class="lance no-right-padding"
                                slot="activator"
                                :value="formatDate(search.createdAtFin)"
                                label="Fecha Final de Pago"
                                append-icon="event"
                                readonly>
                            </v-text-field>
                            <v-date-picker v-model="search.createdAtFin" show-current no-title scrollable locale="es" :header-date-format="formatCalendarHeader">
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="search.createdAtFin=null; $refs.dateCreatedFin.save(search.createdAtFin); searchOnTable();">Cancelar</v-btn>
                                <v-btn flat color="primary" @click="$refs.dateCreatedFin.save(search.createdAtFin); searchOnTable();">Aceptar</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                        <v-menu
                            ref="dateDocumentIni"
                            :close-on-content-click="false"
                            v-model="dateDocumentIni"
                            :nudge-right="40"
                            :return-value.sync="search.dateIni"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                            <v-text-field class="lance no-right-padding"
                                slot="activator"
                                :value="formatDate(search.dateIni)"
                                :label="showColumn('PPD')? 'Fecha Inicial de Complemento': 'Fecha Inicial de Factura'"
                                append-icon="event"
                                readonly>
                            </v-text-field>
                            <v-date-picker v-model="search.dateIni" show-current no-title scrollable locale="es" :header-date-format="formatCalendarHeader">
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="search.dateIni=null; $refs.dateDocumentIni.save(search.dateIni); searchOnTable();">Cancelar</v-btn>
                                <v-btn flat color="primary" @click="$refs.dateDocumentIni.save(search.dateIni); searchOnTable();">Aceptar</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                        <v-menu
                            ref="dateDocumentFin"
                            :close-on-content-click="false"
                            v-model="dateDocumentFin"
                            :nudge-right="40"
                            :return-value.sync="search.dateFin"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                            <v-text-field class="lance no-right-padding"
                                slot="activator"
                                :value="formatDate(search.dateFin)"
                                :label="showColumn('PPD')? 'Fecha Final de Complemento': 'Fecha Final de Factura'"
                                append-icon="event"
                                readonly>
                            </v-text-field>
                            <v-date-picker v-model="search.dateFin" show-current no-title scrollable locale="es" :header-date-format="formatCalendarHeader">
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="search.dateFin=null; $refs.dateDocumentFin.save(search.dateFin); searchOnTable();">Cancelar</v-btn>
                                <v-btn flat color="primary" @click="$refs.dateDocumentFin.save(search.dateFin); searchOnTable();">Aceptar</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                        <v-text-field class="lance"
                            v-model="search.supplementUUID"
                            label="UUID de Complemento"
                            @input="searchOnTable">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                        <v-text-field class="lance"
                            v-model="search.invoiceUUID"
                            label="UUID de Factura"
                            @input="searchOnTable">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                        <v-autocomplete class="lance supplier-select"
                            v-model="search.supplier"
                            :items="suppliers"
                            item-text="businessName"
                            label="Proveedor"
                            @input="searchOnTable"
                            return-object>
                            <v-list-tile v-if="search.supplier" slot="prepend-item" @click="search.supplier = null; searchOnTable();">
                                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                                <v-list-tile-title>Limpiar</v-list-tile-title>
                            </v-list-tile>
                            <v-divider v-if="search.supplier" slot="prepend-item" class="mt-2"></v-divider>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                        <v-select class="lance"
                            :items="status"
                            item-text="internalText"
                            item-value="id"
                            v-model="search.status"
                            label="Estatus Factura"
                            @input="searchOnTable"
                            return-object>
                            <v-list-tile v-if="search.status" slot="prepend-item" @click="search.status = null; searchOnTable();">
                                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                                <v-list-tile-title>Limpiar</v-list-tile-title>
                            </v-list-tile>
                            <v-divider v-if="search.status" slot="prepend-item" class="mt-2"></v-divider>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                        <v-select class="lance"
                            :items="paymentMethods"
                            v-model="search.paymentMethod"
                            label="Método de Pago"
                            @input="searchOnTable">
                        </v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                        <v-text-field class="lance"
                            v-model="search.companyCode"
                            label="Código de la Organización"
                            @input="searchOnTable">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                        <v-text-field class="lance"
                            v-model="search.cd_number"
                            label="Clearing Document"
                            @input="searchOnTable">
                        </v-text-field>
                    </v-flex>
                    <v-flex sm3 md3></v-flex>
                    <v-flex xs12 sm6 md4 lg3 v-if="showColumn('PUE')">
                        <v-text-field class="lance"
                            v-model="configuration.dayPUE"
                            number
                            label="Validacion Dias PUE"
                            @input="setupList">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3 v-if="showColumn('PUE')">
                        <v-text-field class="lance"
                            v-model="configuration.monthPUE"
                            number
                            label="Validacion Meses PUE"
                            @input="setupList">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3 v-if="showColumn('PPD')">
                        <v-text-field class="lance"
                            v-model="configuration.dayPPD"
                            number
                            label="Validacion Dias PPD"
                            @input="setupList">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3 v-if="showColumn('PPD')">
                        <v-text-field class="lance"
                            v-model="configuration.monthPPD"
                            number
                            label="Validacion Meses PPD"
                            @input="setupList">
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

        <div class="table-catalog elevation-5">
            <div class="text-xs-center header-table">

                <div style="display: flex; align-items:center">
                    <div class="navigation-label">
                        <span>Elementos</span>
                        <span class="pl-1 hidden-md-and-down">por página:</span>
                    </div>
                    <div class="pr-4 aux-responsive" style="width: 50px">
                        <v-select
                            class="customInput pa-0"
                            v-model="pagination.rowsPerPage"
                            :items="[5, 10, 20, 30]"
                        ></v-select>
                    </div>

                    <div class="nav-contPag hidden-md-and-down" v-if="pagination.totalItems >  0">
                        <span v-if="pageAct === pages"> {{(pageAct-1)*pagination.rowsPerPage + 1}} - {{pagination.totalItems}} </span>
                        <span v-else> {{(pageAct-1)*pagination.rowsPerPage + 1}} - {{pageAct * pagination.rowsPerPage}} </span>
                        <span>de</span>
                        <span> {{pagination.totalItems}}</span>
                    </div>
                    <div class="hidden-md-and-down" style="width: 145px; padding: 0px 10px" v-else>
                        <span> 0 </span>
                        <span>de</span>
                        <span> {{pagination.totalItems}}</span>
                    </div>
                </div>

                <div style="display: flex; align-items:center">
                    <div class="navPagOf" v-if="pagination.totalItems >  0">
                        <span class="hidden-lg-and-up">Pág:</span>
                        <span class="hidden-md-and-down">Página:</span>
                        <span>de</span>
                        <span> {{pages}}</span>
                    </div>
                    <div class="navPagOf" v-else>
                        <span class="hidden-lg-and-up">Pág:</span>
                        <span class="hidden-md-and-down">Página:</span>
                        <span>  0 </span>
                        <span>de</span>
                        <span> 0 </span>
                    </div>
                </div>

                <div style="min-width: 100px;">
                    <v-btn color="primary" class="ma-0" icon flat @click="leftArrow();">
                        <v-icon>keyboard_arrow_left</v-icon>
                    </v-btn>
                    <span><b>{{pageAct}}</b></span>
                    <v-btn color="primary" class="ma-0" icon flat @click="rightArrow()">
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                    
                </div>
                
                <div style="width: 80px; margin-right: 5px">
                    <span>Ir página</span>
                </div>

                <div style="width: 70px; padding-right: 2px;">
                            <v-text-field
                            class="customInput pa-0"
                            :rules="[numberRule]"
                            v-model="toPage"
                            hide-details
                            @keyup.enter.native="goToPage()"
                            ></v-text-field>
                </div>
                <div style="width: 100px; text-align: left">
                    <v-btn id="btnChPag"
                    outlined
                    small
                    fab
                    @click="goToPage()"
                    v-bind:class="{'active': (toPage > 0 && toPage <= pages)}"
                    > Ir </v-btn>
                </div>

            </div>
            <div style="padding: 10px 20px 0px 20px">
                <v-data-table
                    :headers="filteredHeaders"
                    :items="list"
                    :loading="loading"
                    hide-actions
                    :pagination.sync="pagination">
                    <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props" @click="credentials.PaymentSupplementsUpdate && !props.item.documentPaymentInvoice ? goTo('PaymentSupplementsform/' + props.item.id) : null">
                        <tr
                            class="cursor-pointer"
                            @click="credentials.PaymentSupplementsRead? goTo('PaymentSupplementsdetail/' + props.item.id): null"
                        >
                            <td class="text-xs-left">{{ props.item.invoiceUUID }}</td>
                            <td class="text-xs-left">{{ props.item.supplierCode }}</td>
                            <td class="text-xs-left">{{ props.item.companyCode }}</td>
                            <td class="text-xs-left">{{ props.item.supplier.businessName }}</td>
                            <td class="text-xs-left">{{ props.item.invoiceNum }}</td>
                            <td class="text-xs-left">{{ props.item.netAmount !== null? formatCurrency(props.item.netAmount) : "Sin pago" }}</td>
                            <td v-if="showColumn('PPD')" class="text-xs-left">{{ props.item.documentPaymentInvoice ? props.item.documentPaymentInvoice.documentPayment.amount : 'Sin complemento'}}</td>
                            <td class="text-xs-left">{{ props.item.paymentDate? formatDate(props.item.paymentDate, true): "Sin fecha de pago" }}</td>
                            <td v-if="showColumn('PUE')" class="text-xs-left">{{ formatDate(props.item.date, true) }}</td>
                            <td v-if="showColumn('PPD')" class="text-xs-left">{{ props.item.documentPaymentInvoice ? formatDate(props.item.documentPaymentInvoice.documentPayment.document.date, true) : 'Sin complemento'}}</td>
                            <td v-if="showColumn('PPD')" class="text-xs-left">{{ props.item.isConsignment ? "Sí" : "No" }}</td>
                            <td class="text-xs-left">{{ props.item.cd_number ? props.item.cd_number: "Sin validar" }}</td>
                            <td class="text-xs-left">{{ props.item.documentPaymentInvoice ? props.item.documentPaymentInvoice.documentPayment.document.invoiceUUID : 'Sin complemento' }}</td>
                            <td class="text-xs-left">{{ props.item.warning ? props.item.warning : "No" }}</td>
                            <td class="text-xs-left">{{ getStatus(props.item.status) }}</td>
                        </tr>
                    </template>
                    <template slot="no-data">
                        No hay registros para sus parámetros de búsqueda. Favor de intentar otra búsqueda o crear uno nuevo.
                    </template>
                </v-data-table>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .customInput  >>> .v-select__slot{
        margin-bottom: -10px;
    }
    .customInput  >>> .v-select__slot > .v-select__selections{
        padding-left: 5px;
    }
    .customInput >>> .v-text-field__slot > input {
        text-align: center !important;
        min-width: 45px;
    }
    .navPagOf{
        width: 125px;
    }
    .header-table{
        background-color: #E1ECF3;
        display:flex; 
        align-items:center;         
        justify-content:flex-end;
        border-radius: 18px 18px 0px 0px; 
        border-bottom: solid 2.7px #3A8DCA;
    }
    .navigation-label{
        width:160px; 
        display: flex; 
        align-items:center;
    }
    .nav-contPag{
        width: 145px;
        padding: 0px 10px;
    }
    .active{
        background-color: #5f9fccb4 !important;
    }
    @media screen and (max-width: 1264px) {
        .navPagOf {
            width: 80px;
        }
        .navigation-label {
            width: 80px;
        }
    }

    .search-bar .flex > button.v-btn:not(.v-btn--floating) {
        margin: 0;
        width: 100% !important;
        height: 50px !important;
        text-transform: none;
        border-radius: 100px;
        color: white;
        font-size: 16px;
    }
    .adjust{
        border-radius: 0px 0px 18px 18px !important;
    }
    .table-catalog {
        padding: 0px 0px 30px 0px;
    }

    .table-catalog >>> table.v-table thead th:not(:first-child):not(:last-child),
    .table-catalog >>> table.v-table tbody td:not(:first-child):not(:last-child) {
        padding-left: 15px;
    }

    .table-catalog >>> table.v-table thead th:not(:nth-last-child(2)):not(:last-child),
    .table-catalog >>> table.v-table tbody td:not(:nth-last-child(2)):not(:last-child) {
        padding-right: 15px;
    }

    .table-catalog >>> table.v-table thead tr th {
        font-size: 14px;
        font-weight: bold;
    }

    .table-catalog >>> table.v-table tbody tr td {
        font-size: 12px;
    }

</style>

<style>
    .supplier-select .v-input__control .v-input__slot .v-select__slot  {
        height: 50px !important;
    }
</style>

<script>
    import { events, printList } from '../main';
    import _ from 'underscore';
    import xlsx from 'xlsx';
    import moment from 'moment-timezone';
    import filterMethod from '../utils/filterMethods';

    export default {
        mixins: [filterMethod],
        components: { 
        },
        computed: {
            filteredHeaders() {
                return this.headers.filter(h => !h.method || h.method == this.search.paymentMethod);
            },
            pages() {
                if (
                    this.pagination.rowsPerPage == null ||
                    this.pagination.totalItems == null
                ) {
                    return 0;
                }

                return Math.ceil(
                    this.pagination.totalItems / this.pagination.rowsPerPage
                );
            },
        },
        data () {
            return {
                list: [],
                source: [],
                suppliers: [],
                supplierTypes: [],
                documentTypes: [
                    { value: 1, name: 'Factura' },
                    { value: 2, name: 'Complemento de pago' },
                ],
                pageAct: 1,
                toPage: null,
                isSearchC: false,
                isSearchP: false,
                status: [],
                paymentMethods: ['PUE', 'PPD'],
                configuration: {},
                dateCreatedIni: false,
                dateCreatedFin: false,
                dateDocumentIni: false,
                dateDocumentFin: false,
                search: {
                    createdAtIni: moment().locale("es").format("YYYY-MM-DD"),
                    createdAtFin: moment().locale("es").format("YYYY-MM-DD"),
                    dateIni: null,
                    dateFin: null,
                    invoiceUUID: "",
                    supplementUUID: "",
                    paymentMethod: 'PPD',
                    supplier: null,
                    status: null,
                    companyCode: "",
                    cd_number: "",
                    rowsPP: 10,
                    currentPage: 1,
                    sortBy: null,
                    descending: null
                },
                showFilters: false,
                headers: [
                    { text: 'UUID de Factura', value: 'invoiceUUID' },
                    { text: 'No. Proveedor', value: 'supplierCode' },
                    { text: 'Código de la Organización', value: 'companyCode' },
                    { text: 'Proveedor', value: 'supplier.businessName' },
                    { text: 'Folio de la Factura', value: 'invoiceNum' },
                    { text: 'Monto Neto Pagado', value: 'netAmount' },
                    { text: 'Monto de Complemento de Pago', value: 'documentPaymentInvoice.documentPayment.amount', method: 'PPD' },
                    { text: 'Fecha de Pago', value: 'paymentDate' },
                    { text: 'Fecha de Factura', value: 'date', method: 'PUE' },
                    { text: 'Fecha de Complemento', value: 'documentPaymentInvoice.documentPayment.document.date', method: 'PPD' },
                    { text: 'Consignación', value: 'isConsignment', method: 'PPD' },
                    { text: 'Clearing Document', value: 'cd_number' },
                    { text: 'UUID de Complemento', value: 'documentPaymentInvoice.documentPayment.document.invoiceUUID' },
                    { text: 'Advertencia', value: 'warning' },
                    { text: 'Estatus Factura', value: 'status' },
                ],
                pagination: {
                    sortBy: "invoiceUUID",
                    descending: true,
                    rowsPerPage: 10,
                    page: 1
                },
                loading: true,
                credentials: JSON.parse(localStorage.getItem('userCredentials')),
                numberRule: v  => {
                    if (v != undefined){
                        if (!v.trim()) return true;
                        if (!isNaN(parseFloat(v)) && v > 0 && v <= this.pages) return true;
                        }
                    return "false";
                },
            }
        },
        methods: {
            leftArrow(){
                if(this.pageAct > 1){
                    this.pageAct--;
                }
            },rightArrow(){
                if(this.pageAct < this.pages){
                    this.pageAct++;
                }
            },
            goToPage(){
                if(this.toPage){
                    if(this.toPage > 0 && this.toPage <= this.pages)
                        this.pageAct = Number(this.toPage);
                    else
                        this.snackbar("No existe el número de página ingresado");
                }
            },
            snackbar: function(message) {
                events.$emit('snackbar', message);            
            },
            goTo(url) {
                var self = this;
                self.$router.push('/' + url);
            },
            formatCalendarHeader(val) {
                return moment(val).locale("es").format("MMMM YYYY");
            },
            formatCurrency(num) {
                return "$ " + Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            },
            formatDate(date, withUtc=false) {
                if(date) {
                    let mdate = moment(date);
                    if (withUtc) mdate = mdate.utc();
                    var ndate = moment(mdate).locale("es").format("DD/MMM/YYYY");
                    var mes = ndate.split("/")[1];
                    var nmes = mes.charAt(0).toUpperCase() + mes.slice(1, -1);
                    return ndate.replace(mes, nmes);
                }
                return '';
            },
            formatTime(date) {
                return date ? moment(date).locale("es").format("HH:mm:ss a") : '';
            },
            getStatus(value) {
                let s = this.status.find(x => x.id == value);
                return s? s.internalText: "";
            },
            getDocumentType(value) {
                let t = this.documentTypes.find(x => x.value == value);
                return t? t.name: "";
            },
            getSupplierType(value) {
                let t = this.supplierTypes.find(x => x.id == value);
                return t? t.name: "";
            },
            setupList() {
                this.list = this.list.map(item => {
                    if (item.supplierRFC != item.supplier.rfc) {
                        item.supplierCode = '';
                        item.supplier.businessName = '';
                    }
                    if (!item.isConsignment && item.documentPaymentInvoice) {
                        item.isConsignment = item.documentPaymentInvoice.documentPayment.paymentMethod == "14";
                    }
                    // "Monto Neto Pagado"
                    item.netAmount = null;
                    // "Clearing Document" Column
                    item.cd_number = null;
                    // "Fecha de Pago" Column
                    item.paymentDate = null;
                    
                    // check if we have RFC3 data
                    if (Array.isArray(item.rfc3data) && item.rfc3data.length > 0) {
                        item.cd_number = item.rfc3data[0].cd_number;
                        item.paymentDate = (item.documentPaymentInvoice || item.rfc3data[0]) ? 
                            item.documentPaymentInvoice ? item.documentPaymentInvoice.documentPayment.date : item.rfc3data[0].posting_date : null;
                        if (item.rfc3data.length >= 2) {
                            item.netAmount = item.rfc3data.reduce((prev, curr) => prev + Number(curr.cd_amount) - Number(curr.cd_witaxamount) , 0);
                        } else {
                            item.netAmount = item.rfc3data[0].amount - item.rfc3data[0].witaxamount;
                        }
                    }
                    item.warning = "No hay advertencia";
                    if (item.paymentMethod == "PUE") {
                        if (!this.configuration) {
                            item.warning = "Revisar configuracion";
                        } else if(item.rfc3data[0] && item.date){
                            if (item.rfc3data[0].posting_date && moment(item.rfc3data[0].posting_date).isAfter(moment(item.date).add({days: this.configuration.dayPUE, months: this.configuration.monthPUE}), 'day'))
                                item.warning = "Revisar, posible re facturación por fecha de pago";
                            else if (!item.rfc3data[0].posting_date && moment().isAfter(moment(item.date).add({days: this.configuration.dayPUE, months: this.configuration.monthPUE}), 'day')) 
                                item.warning = "Revisar, posible re facturación por fecha de pago";
                            
                        }
                    } else if (item.paymentMethod == "PPD") {
                        if (!item.documentPaymentInvoice) {
                            if (item.netAmount && item.paymentDate) 
                                item.warning = "Pendiente de recibirlo";
                        } else if (moment(item.documentPaymentInvoice.documentPayment.document.date).isAfter(moment(item.date).add({days: this.configuration.dayPPD, months: this.configuration.monthPPD}), 'day')) {
                            item.warning = "Revisar, fecha de complemento de pago superior a la permitida por SAT"
                        }
                    }
                    return item;
                });
            },
            getList: function(oldVal = 0) {
                let createdEvalIni = this.search.createdAtIni ? this.search.createdAtIni : "notSent";
                let createdEvalFin = this.search.createdAtFin ? this.search.createdAtFin : "notSent";
                let dateEvalIni = this.search.dateIni ? this.search.dateIni : "notSent";
                let dateEvalFin = this.search.dateFin ? this.search.dateFin: "notSent"; 
                let supplierEval = this.search.supplier ? this.search.supplier.businessName.replace("&", "=") : "notSent";
                let statusEval = this.search.status ? this.search.status.id : "notSent";
                let invoiceUUIDEval = this.search.invoiceUUID ? this.search.invoiceUUID : "notSent"; 
                let supplementUUIDEval = this.search.supplementUUID ? this.search.supplementUUID : "notSent"; 
                let paymentMethodEval = this.search.paymentMethod ? this.search.paymentMethod : "notSent";
                let companyCodeEval = this.search.companyCode ? this.search.companyCode : "notSent"; 
                let SAPEval = this.search.cd_number ? this.search.cd_number : "notSent"; 
                let cfgD = this.configuration ? paymentMethodEval == "PUE" ?this.configuration.dayPUE :this.configuration.dayPPD :"notSent";
                let cfgM = this.configuration ? paymentMethodEval == "PUE" ?this.configuration.monthPUE :this.configuration.monthPPD :"notSent";

                let opcs = {'page':oldVal, 'size':this.pagination.rowsPerPage, 'orderBy': this.pagination.sortBy,
                    'desc': this.pagination.descending ? "DESC" : "ASC", 'createdAtIni': createdEvalIni, 'createdAtFin': createdEvalFin,
                    'dateEvalIni': dateEvalIni, 'dateEvalFin': dateEvalFin, 'supplierEval': supplierEval, 'statusEval': statusEval, 
                    'invoiceUUIDEval': invoiceUUIDEval, 'supplementUUIDEval': supplementUUIDEval, 'paymentMethodEval': paymentMethodEval,
                    'companyCodeEval': companyCodeEval, 'SAPEval': SAPEval, 'cfgD' : cfgD, cfgM : cfgM };

                this.$http.get(`PaymentSupplements/listValidatedInvoices`,{params: opcs})
                    .then(response => {
                        this.list = response.data.documents;
                        this.loading = false;
                        this.pagination.totalItems = response.data.totalItems;
                        this.setupList();
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista');
                        console.error(error);
                    })
            },
            getSuppliers: function() {
                this.$http.get('PaymentSupplements/Suppliers')
                    .then(response => {
                        var list = response.body;
                        this.suppliers = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de proveedores');
                        console.error(error);
                    })
            },
            getSupplierTypes: function() {
                this.$http.get('SupplierType')
                    .then(response => {
                        var list = response.body;
                        this.supplierTypes = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de tipos de proveedores');
                        console.error(error);
                    })
            },
            getStatuses: function() {
                this.$http.get('Status/invoiceStatuses')
                    .then(response => {
                        var list = response.body;
                        this.status = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de estatus');
                        console.error(error);
                    })
            },
            getConfiguration: function() {
                return new Promise( (resolve, reject) => {
                    this.$http.get('Configuration').then(response => {
                        var list = response.body;
                        if (list.length > 0) {
                            this.configuration = list[0];
                        }
                        resolve();
                    }).catch(reject);
                });
            },
            searchOnTable: function() {
                    this.isSearchP = true;
                    if(!this.isSearchC){
                        if(this.pageAct === 1)
                            this.getList(0);
                        else
                            this.pageAct = 1;
                    }else{
                        this.getList(this.pageAct-1);
                    }
            },
            showColumn(value) {
                return value == this.search.paymentMethod;
            },
            exportToCSV() {
                let createdEvalIni = this.search.createdAtIni ? this.search.createdAtIni : "notSent";
                let createdEvalFin = this.search.createdAtFin ? this.search.createdAtFin : "notSent";
                let dateEvalIni = this.search.dateIni ? this.search.dateIni : "notSent";
                let dateEvalFin = this.search.dateFin ? this.search.dateFin: "notSent"; 
                let supplierEval = this.search.supplier ? this.search.supplier.businessName.replace("&", "=") : "notSent";
                let statusEval = this.search.status ? this.search.status.id : "notSent";
                let invoiceUUIDEval = this.search.invoiceUUID ? this.search.invoiceUUID : "notSent"; 
                let supplementUUIDEval = this.search.supplementUUID ? this.search.supplementUUID : "notSent"; 
                let paymentMethodEval = this.search.paymentMethod ? this.search.paymentMethod : "notSent";
                let companyCodeEval = this.search.companyCode ? this.search.companyCode : "notSent"; 
                let SAPEval = this.search.cd_number ? this.search.cd_number : "notSent"; 
                let cfgD = this.configuration ? paymentMethodEval == "PUE" ?this.configuration.dayPUE :this.configuration.dayPPD :"notSent";
                let cfgM = this.configuration ? paymentMethodEval == "PUE" ?this.configuration.monthPUE :this.configuration.monthPPD :"notSent";

                let opcs = {'createdAtIni': createdEvalIni, 'createdAtFin': createdEvalFin,
                    'dateEvalIni': dateEvalIni, 'dateEvalFin': dateEvalFin, 'supplierEval': supplierEval, 'statusEval': statusEval, 
                    'invoiceUUIDEval': invoiceUUIDEval, 'supplementUUIDEval': supplementUUIDEval, 'paymentMethodEval': paymentMethodEval,
                    'companyCodeEval': companyCodeEval, 'SAPEval': SAPEval, 'cfgD' : cfgD, cfgM : cfgM };

                this.$http.get(`PaymentSupplements/toCSVSupplements`,{params: opcs})
                    .then((response) => {
                    let blob = new Blob([response.body], { type:"text/csv" })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'complementosPago - ' + moment().locale("es").format("YYYY-MM-DD") + '.csv'
                    link.click()
                },
                (error) => {
                    this.snackbar("Hubo un problema al procesar el CSV");
                    console.error(error);
                });
            }
        },
        mounted() {
            this.search = this.loadFilters(this.search);
            this.pagination.sortBy = this.search.sortBy ? this.search.sortBy : "invoiceUUID";
            this.pagination.descending = this.search.descending == null ? true : this.search.descending;
            this.pagination.rowsPerPage = this.search.rowsPP != undefined ? this.search.rowsPP : 10;
            this.pageAct = this.search.currentPage != undefined ? this.search.currentPage : 1;
            this.isSearchC = this.pageAct > 1 ? true : false;

            this.getConfiguration().then(r => {
                this.getSuppliers();
                this.getSupplierTypes();
                this.getStatuses();
                this.getList();
            });
        },
        filters: {
            moment: function (date) {
                return moment(date).locale("es").format('LL');
            }
        },
        watch: {
            search: {
                handler(value) {
                    this.saveFilters(this.search);
                },
                deep: true,
                immediate: false
            },
            pagination(newVal, oldVal){
                if(newVal.sortBy == null){
                    newVal.descending = false;
                    newVal.sortBy = oldVal.sortBy;
                }
                if(newVal.sortBy){
                    this.list = [];
                    this.loading = true;
                    this.search.descending = newVal.descending;
                    this.search.sortBy = newVal.sortBy;
                    this.saveFilters(this.search);
                    this.searchOnTable();
                }
            },
            pageAct(newVal, oldVal) {
                    this.search.rowsPP = this.pagination.rowsPerPage;
                    this.search.currentPage = newVal;
                    this.saveFilters(this.search);
                    if(!this.isSearchC)
                        this.getList(newVal - 1);
                    else
                        this.isSearchC = false;
            },
            pages(newVal, oldVal) {
                this.search.rowsPP = this.pagination.rowsPerPage;
                this.saveFilters(this.search);
                if(!this.isSearchP){
                    if(this.pageAct == 1){
                        this.getList(0);
                    }else
                        this.pageAct = 1;
                }else
                    this.isSearchP = false;
            },
        },
    }
</script>